<template>
  <div>
    <Welcome/>
    <WelcomeFeatures/>
    <Servers :preview="true"/>
    <WelcomeSoftware/>
    <TextSection mode="light" message_id="server_features" image_name="serverfeatures.jpg"/>
    <!-- <Spacer/>
    <TextSection right mode="light" message_id="about_us" image_name="us.jpg"/> -->
  </div>
</template>

<script>
import TextSection from "@/components/TextSection";
//import Spacer from "@/components/Spacer";

import Servers from "@/views/Servers";
import Welcome from "@/views/Welcome";
import WelcomeFeatures from "@/views/WelcomeFeatures";
import WelcomeSoftware from "@/views/WelcomeSoftware";

export default {
  name: 'Home',
  components: {
    TextSection,
    Servers,
    Welcome,
    WelcomeFeatures,
    WelcomeSoftware,
    //Spacer,
  },
}
</script>
